import { AssetPermission } from '@deltasierra/frontend-graphql-core';
import { AssetType, MimeType } from '../constants';
import { Asset, AssetFile } from '../types';

export const mapAssetFileToAsset = (assetFile: AssetFile, permissions: AssetPermission[]): Asset => {
    const asset: Asset = {
        dateAdded: assetFile.created,
        expiry: assetFile.expires,
        fileSize: assetFile.size,
        id: assetFile.id,
        mimeType: assetFile.mimeType as MimeType,
        name: assetFile.fileName,
        permissions,
        tags: assetFile.tags,
        title: assetFile.title,
        type: AssetType.Asset,
        url: assetFile.url,
    };
    if (assetFile.thumbnails?.medium) {
        asset.thumbnailDimensions = {
            height: assetFile.thumbnails.medium.height,
            width: assetFile.thumbnails.medium.width,
        };
        asset.thumbnailUrl = assetFile.thumbnails.medium.url;
    }
    return asset;
};
